export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "What is the other term for crosswalk?",
    options: ["Pedestrian Path", "Pedestrian Lane", "Crossing Lane"],
    correctAnswer: "Overtaking and changing lanes is not allowed",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
